import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    container: {
        maxHeight: '80vh'
    }
}));

export {useStyles};